/*
* there were two main reasons why we decided to go with JQuery for this functionality
* 1) This code will leave under wordpress and wordpress installation is already loading jquery
* 2) and more important, we are using the the JQuery autocomplete extension for the search input.
*    The extensions did allows to implement what we were looking for with few lines of code. And because we
*    are using some of the extension callbacks/hooks we decided it was just easier to continue to utilise jQuery.
 */
const gateway_search_filters = ($) => {
    let $searchForm = $('.n-gateway-search-form');

    $searchForm.each(function () {
        let $currSearchForm = $(this);

        $currSearchForm.submit(function (e) {
            e.preventDefault();
        });
        // support elements       
        let $searchInput = $currSearchForm.find(".n-gateway-search-control");
        let btnIcon = $currSearchForm.find('.n-gateway-search-submit');
        let inputLabel = $currSearchForm[0].querySelector('.n-gateway-search-label');
        let searchMesure = $currSearchForm[0].querySelector('.n-gateway-search-measure');
        let searchMesureTxt = searchMesure.querySelector('div');

        // see arcgis.gateway-search-redirection.js
        arcgis_search_redirection($searchInput, btnIcon, $currSearchForm);

        let authors = arcgis_object.authors.map(author => `@${author.name}`);
        let tags = arcgis_object.tags.map(tag => `#${tag.name}`);
        let isTagOrAuthor = /^(#|@)/;
        let advSearch = [];
        let newSelection = false;

        // add custom width to autocomplete using jquery
        $.widget("custom.autocomplete", $.ui.autocomplete, {
            _resizeMenu: function () {
                this.menu.element.outerWidth(500);
            }
        });

        $searchInput.autocomplete({
            source: advSearch,
            minLength: 2,
            _resizeMenu: function () {
                this.menu.element.outerWidth(500);
            }
        });

        // set data attr to true:
        $searchInput.data('autocomplete', true);

        // set or remove autocomplete
        $searchInput.keyup(function () {

            var queryTxt = jQuery(this).val();
            styleInputOnKeyUp(queryTxt);
            //only check the first character
            if (queryTxt.length < 2) {
                let isSpecialQuery = queryTxt.match(isTagOrAuthor);

                if (isSpecialQuery) {
                    advSearch = queryTxt.indexOf('#') == 0 ? tags : authors;
                    $searchInput.autocomplete({
                        source: advSearch,
                        minLength: 2,
                        select: function () {
                            newSelection = true;
                        },
                        close: function () {
                            if (newSelection) {
                                queryTxt = $searchInput.val();
                                styleInputOnKeyUp(queryTxt);
                                btnIcon.click();
                            }
                            newSelection = false;
                        },
                        _resizeMenu: function () {
                            this.menu.element.outerWidth(500);
                        }
                    });
                    $searchInput.data('autocomplete', true);
                } else {
                    let isActive = $searchInput.data('autocomplete');
                    if (isActive) {
                        $searchInput.autocomplete("destroy").data('autocomplete', false);
                    }
                }
            } else {
            }

        });


        function styleInputOnKeyUp(inputValue) {
            if (!inputLabel.hasAttribute('data-filled')) {
                inputLabel.setAttribute('data-filled', '');
            }
            if (inputValue) {
                searchMesureTxt.innerHTML = inputValue;
                searchMesure.style.width = `${searchMesureTxt.scrollWidth}px`;
            } else {
                searchMesureTxt.innerHTML = '';
                searchMesure.style.width = "0px";
            }
        }
        $searchInput.blur(function (event) {
            if (!event.target.value) {
                inputLabel.removeAttribute('data-filled');
            }
        });
    });
}

  /* dsdfsd */